export default "__VITE_ASSET__CxbatyM7__"